"use client";

import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";

import { cn } from "@/lib/utils";

interface CustomSliderProps
    extends React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> {
    hideThumb?: boolean;
    trackRangeClassName?: string;
    trackColorBg?: string;
    trackColor?: string;
}
const Slider = React.forwardRef<
    React.ElementRef<typeof SliderPrimitive.Root>,
    CustomSliderProps
>(
    (
        {
            className,
            hideThumb,
            trackRangeClassName = "",
            trackColor = "",
            trackColorBg = "",
            ...props
        },
        ref
    ) => (
        <SliderPrimitive.Root
            ref={ref}
            className={cn(
                "relative flex w-full touch-none select-none items-center",
                className
            )}
            {...props}
        >
            <SliderPrimitive.Track
                className={cn(
                    "relative h-1.5 w-full grow overflow-hidden rounded-full bg-primary/20",
                    trackRangeClassName
                )}
                style={{
                    background: trackColorBg && trackColorBg,
                }}
            >
                <SliderPrimitive.Range
                    className={cn("absolute h-full bg-primary")}
                    style={{
                        background: trackColor && trackColor,
                    }}
                />
            </SliderPrimitive.Track>
            {!hideThumb && (
                <SliderPrimitive.Thumb className="block h-4 w-4 rounded-full border border-primary/50 bg-background shadow transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50" />
            )}
        </SliderPrimitive.Root>
    )
);
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
